import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { ProfileService } from '../services/profile/profile.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private profile = inject(ProfileService);
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (!(await this.authService.isLoggedin())) {
      return this.router.createUrlTree(['initial'], { queryParamsHandling: 'preserve' });
    }

    if (!this.profile.profile) await this.profile.getProfile();
    return true;
  }
}
